import * as d3 from "d3";
import { sankey as sankeyChart, sankeyLinkHorizontal } from "d3-sankey";
import {
  addSelectDegreeTexttoChart,
  removeNotificationTextfromChart
} from "./bar-chart";
import { linspace } from "./utilities";
import { fipsToState } from "./constants";

const transitionDuration = 400;
const margin = { top: 40, right: 70, bottom: 26, left: 55 };
const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
const SANKEYLINKLIMIT = !isFirefox ? 800 : 12;

// D3 Vars
let chartDiv = document.getElementById("chart");
let width = +chartDiv.clientWidth - margin.left - margin.right;
let height = +chartDiv.clientHeight - margin.top - margin.bottom;

// hidden filter global
let hiddenFilter = false;
let hiddenFilterString = null;
let instateDivision = null;

const nodeSort = (a, b) => (a.value > b.value ? -1 : 1);
let sankey = sankeyChart()
  .nodeWidth(24)
  .nodePadding(10)
  .nodeSort(nodeSort)
  .iterations(6);
// sankey iterations - default 6
// If iterations is specified, sets the number of relaxation iterations when generating the layout and returns this Sankey generator.

// wrap long text
function wrap(text, width) {
  text.each(function() {
    var text, words, word, line, lineNumber, lineHeight, y, dy, tspan;
    text = d3.select(this);
    words = text
      .text()
      .split(/\s+/)
      .reverse();
    line = [];
    lineNumber = 0;
    lineHeight = 1.1;
    y = text.attr("y");
    dy = parseFloat(text.attr("dy"));
    tspan = text
      .text(null)
      .append("tspan")
      .attr("x", 0)
      .attr("y", y)
      .attr("dy", dy + "em");
    while ((word = words.pop())) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text
          .append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", function() {
            return ++lineNumber * lineHeight + dy + "em";
          })
          .text(word);
      }
    }
  });
}

function scaleD3Chart() {
  let svg = d3.select(chartDiv).select("svg");

  // update the width and height when window resized
  width = +chartDiv.clientWidth - margin.left - margin.right;
  height = +chartDiv.clientHeight - margin.top - margin.bottom;

  //scale the svg
  svg
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom);

  // scale the chart area
  svg
    .select("g.chart")
    .attr("width", width + margin.right)
    .attr("height", height + margin.bottom)
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
}

export function clearYAxisLabels() {
  let svg = d3.select("#chart").select("svg");
  //redraw axis text
  svg
    .selectAll(".yaxislabel")
    .selectAll("text")
    .remove();
}

function drawYAxisLabels(type) {
  let propCase = type[0].toUpperCase() + type.substr(1).toLowerCase();
  let axisText = `${propCase} of Graduates`;

  let svg = d3.select(chartDiv).select("svg");
  svg
    .select(".yaxislabel")
    .append("text")
    .attr("class", "yaxislabel")
    .attr("transform", "rotate(-90)")
    .attr("x", -185)
    .attr("y", -45)
    .attr("dy", ".71em")
    .attr("fill", "#000")
    .attr("text-anchor", "end")
    .attr("font-family", "Helvetica, Arial, sans-serif;")
    .text(axisText);
}

function reDrawYAxisLabels(type, flowsOptions) {
  clearYAxisLabels();
  drawYAxisLabels(type, flowsOptions);
}

export function initD3SankeyChart() {
  let svg = d3.select(chartDiv).select("svg");

  svg
    .select("g.chart")
    .selectAll("*")
    .remove();

  let chart = svg.select("g.chart");
  chart.append("g").attr("class", "contents");
  chart.append("g").attr("class", "xaxis");
  chart.append("g").attr("class", "yaxislabel");
  chart.append("g").attr("class", "suppressed");

  let contents = svg.select("g.chart").select("g.contents");

  // add the components to the layout
  contents.append("g").attr("class", "nodes");
  contents.append("g").attr("class", "links");
  contents.append("g").attr("class", "labels");

  //scale the svg to the area
  scaleD3Chart();

  let twoToggleDiv = $j33("#twotoggle").parent();
  twoToggleDiv.addClass("d-none");
  let threeToggleDiv = $j33("#threetoggle").parent();
  threeToggleDiv.addClass("d-none");
  let flowsToggleDiv = $j33("#flowstoggle").parent();
  if (flowsToggleDiv.hasClass("d-none")) {
    flowsToggleDiv.removeClass("d-none");
  }
  let flowsDisplayDiv = $j33("#flows-display").parent();
  if (flowsDisplayDiv.hasClass("d-none")) {
    flowsDisplayDiv.removeClass("d-none");
  }
  let legendDiv = $j33("#legend").parent();
  legendDiv.addClass("d-none");

  let flowsSelectedCutDiv = $j33("#flows-selected-cut").parent();
  if (flowsSelectedCutDiv.hasClass("d-none")) {
    flowsSelectedCutDiv.removeClass("d-none");
  }
}

function clearSuppressionText() {
  let svg = d3.select(chartDiv).select("svg");
  let suppressed = svg.select("g.chart").select("g.suppressed");
  suppressed.selectAll("text").remove();
}

function addSuppressionText(rootNodes, cipCodeFilter) {
  let svg = d3.select(chartDiv).select("svg");
  let suppressed = svg.select("g.chart").select("g.suppressed");
  if (rootNodes.length === cipCodeFilter.length) {
    clearSuppressionText();
  } else {
    clearSuppressionText(); // prevent overlapping text when loading from URL
    let unmatchedDegrees = cipCodeFilter
      .filter(obj => {
        return !rootNodes.includes(obj.cipCodeLabel);
      })
      .map(obj => obj.cipCodeLabel);
    let unmatchedText = unmatchedDegrees.join("; ");
    suppressed
      .append("text")
      .attr("x", 0)
      .attr("y", height+4)
      .attr("dy", ".71em")
      .attr("fill", "#000")
      .attr("text-anchor", "start")
      .attr("font-family", "Helvetica, Arial, sans-serif;")
      .style("font-size", "10px")
      .text(`Supressed: ${unmatchedText}`)
      .call(wrap, width)
    ;
  }
}

function patchAll(data, keys, filter) {
  // if 00 and some other cips are selected, remove the selected cip totals
  // from the 00 all total and update the label to reflect the change
  if (!filter.some(obj => obj.cipCode === "00")) {
    return data; // short circuit if all isn't available
  }
  let allLabel = "All Instructional Programs";

  let allData = data.filter(obj => obj.degree === allLabel);
  let cipData = data.filter(obj => obj.degree !== allLabel);

  // * this could be cleaned up with some parameter/var substitution of keys
  allData.forEach(allObj => {
    let matched = cipData.filter(cipObj => {
      if (keys.length === 1 && keys[0] === "status") {
        return cipObj.status === allObj.status;
      } else if (keys.length === 1 && keys[0] === "geography") {
        return cipObj.geography === allObj.geography;
      } else if (keys.length === 1 && keys[0] === "industry") {
        return cipObj.industry === allObj.industry;
      } else if (keys.length === 2) {
        return (
          cipObj.geography === allObj.geography &&
          cipObj.industry === allObj.industry
        );
      } else {
        console.log("Error: unrecognized keys when patching 00");
        console.log(keys);
        return;
      }
    });

    // subtract all matched values from the 00 all total
    matched.forEach(matchObj => {
      allObj.value -= matchObj.value;
    });

    // rename the total to indicate the change
    allObj.degree = "All Other Instructional Programs";
  });

  // remove any persistent zeroes in the all remainders
  allData = allData.filter(obj => obj.value !== 0);

  return [...allData, ...cipData];
}

function pickGradCountAttr(
  dataType,
  analysis_type,
  selected_cut,
  flowsSelectedCut
) {
  // this function determines which count of grads should be used to
  // label/sort buttons depending on the datatype, analysis type, and selected cut
  // of the displayed data

  if (dataType === "earnings") {
    if (analysis_type === "earnings-percentile") {
      return `max_grads`;
    } else {
      return `y${selected_cut}_grads`;
    }
  } else {
    return `y${flowsSelectedCut}_grads`;
  }
}

function updateAllButtonHoverover(
  buttonData,
  dataType,
  analysis_type,
  selected_cut,
  flowsSelectedCut,
  cipCodeFilter
) {
  if (!buttonData || Object.keys(buttonData).length === 0) {
    return;
  }

  // update the all label to note that it's a remainder
  // also update the grad count hoverover to display the remainder
  let btn = $j33(`#checkbox-grid > label > #00`).parent();
  let allObj = buttonData.find(obj => obj.cipcode === "00");
  let gradCountAttr = pickGradCountAttr(
    dataType,
    analysis_type,
    selected_cut,
    flowsSelectedCut
  );
  let activeFilters = cipCodeFilter.map(function(obj) {
    return obj.cipCode;
  });

  if (activeFilters.length === 0) {
    // use the default button label
    let val = allObj[gradCountAttr]
      ? `${allObj[gradCountAttr].toLocaleString()} Graduates`
      : `Graduate Count Suppressed`;
    btn.prop("title", `${allObj.cipcode_label} - ${val}`);
    btn.children("div.label").html(allObj.cipcode_label);
  } else if (
    // if the all category is used with any other category
    activeFilters.length > 1 &&
    activeFilters.includes("00") &&
    activeFilters.some(ele => ele !== "00")
  ) {
    // calculate the difference between the sum of selected filters and all
    let allButtonData = buttonData.find(obj => obj.cipcode === "00");
    let otherButtonData = buttonData.filter(
      obj => activeFilters.includes(obj.cipcode) && obj.cipcode !== "00"
    );
    let gradCount = allButtonData[gradCountAttr];
    otherButtonData.forEach(obj => (gradCount -= obj[gradCountAttr]));
    let val = gradCount
      ? `${gradCount.toLocaleString()} Graduates`
      : `Graduate Count Suppressed`;
    btn.prop("title", `All Other Instructional Programs - ${val}`);
    btn.children("div.label").html("All Other Instructional Programs");
  } else if (
    dataType === "flows" &&
    activeFilters.some(ele => ele !== "00") &&
    !activeFilters.includes("00")
  ) {
    // if flows and some other filter is active but not 00
    let val = allObj[gradCountAttr]
      ? `${allObj[gradCountAttr].toLocaleString()} Graduates`
      : `Graduate Count Suppressed`;
    btn.prop("title", `$All Other Instructional Programs - ${val}`);
    btn.children("div.label").html("All Other Instructional Programs");
  } else {
    // use the default button label
    let val = allObj[gradCountAttr]
      ? `${allObj[gradCountAttr].toLocaleString()} Graduates`
      : `Graduate Count Suppressed`;
    btn.prop("title", `${allObj.cipcode_label} - ${val}`);
    btn.children("div.label").html(allObj.cipcode_label);
  }
}

function formatD3NoDataSankey({
  cipCodeFilter,
  cipCodeData,
  flowsSelectedCut,
  flowsDisplay,
  buttonData,
  dataType,
  analysis_type,
  selected_cut
}) {
  // update the cell count on the all button hover
  updateAllButtonHoverover(
    buttonData,
    dataType,
    analysis_type,
    selected_cut,
    flowsSelectedCut,
    cipCodeFilter
  );

  if (!cipCodeData) {
    return;
  }

  let d3Data = [];

  // get the all category, find the remainder flows to undefined in either cip or naics
  cipCodeFilter.forEach(filt => {
    let d3All = {},
      d3Remainder = {};
    d3All.degree = d3Remainder.degree = filt.cipCodeLabel;
    d3All.status = "Employed";
    d3Remainder.status = "No or very low earnings observed";

    // flows to all industries and all geographies
    let allData = cipCodeData.find(
      obj =>
        filt.cipCode === obj.cipcode &&
        obj.geography === "00" &&
        obj.industry === "00"
    );

    if (!allData) {
      console.log(`Error: missing all category for ${filt.cipCodeLabel}`);
      return;
    }

    // flows to employed
    d3All.value = allData[`y${flowsSelectedCut}_grads_emp`];
    if (d3All.value > 0) {
      d3Data.push(d3All);
    }

    // flows to unemployed
    d3Remainder.value = allData[`y${flowsSelectedCut}_grads_nme`];
    if (d3Remainder.value > 0) {
      d3Data.push(d3Remainder);
    }

  });

  // if the data contains an all category plus another
  if (
    cipCodeFilter.some(obj => obj.cipCode === "00") &&
    cipCodeFilter.some(obj => obj.cipCode !== "00")
  ) {
    d3Data = patchAll(d3Data, ["status"], cipCodeFilter);
  }

  // calculate sharre
  if (flowsDisplay === "share") {
    let selectedTotal = 0;

    d3Data.forEach(obj => {
      selectedTotal += obj.value;
    });

    d3Data.forEach(obj => {
      obj.value = obj.value / selectedTotal;
    });
  }

  let d3Keys = ["degree", "status"];

  return generateGraph(d3Keys, d3Data, cipCodeFilter);
}

// format the input data into a node-tree structure
function formatD3DataSankey(pseoData, hiddenFilterString = null) {
  let {
    cipCodeFilter,
    cipCodeData,
    flowsOptions,
    flowsSelectedCut,
    institution_statefips,
    flowsDisplay,
    buttonData,
    dataType,
    analysis_type,
    selected_cut
  } = pseoData;

  // update the cell count on the all button hover
  updateAllButtonHoverover(
    buttonData,
    dataType,
    analysis_type,
    selected_cut,
    flowsSelectedCut,
    cipCodeFilter
  );

  // don't do anything if there's not data to display
  if (!cipCodeData) {
    return;
  }

  let d3Data = [];

  //options flags
  let industryFlag = flowsOptions.includes("industry");
  let geographyFlag = flowsOptions.includes("geography");

  //find which division is instate for labeling below
  let tempVar = cipCodeData.find(
    obj =>
      obj[`y${flowsSelectedCut}_grads_emp_instate`] > 0 &&
      obj.geography !== "00" &&
      obj.geography !== "Z"
  );
  let instateGeography = tempVar ? tempVar.geography : null;

  // iterate through raw flows data, filter, and format
  cipCodeData.forEach(obj => {
    // don't render ZZ categories in the viz as it screws up in/out state
    if (obj.industry === "ZZ" || obj.geography === "Z") {
      return;
    }

    let d3Entry = {};

    // dump the 00 all category rows when not needed
    // only keep 00 when the sub categories aren't needed
    if (industryFlag && obj.industry === "00") {
      // if detailed industries are requested dump 00/all
      return;
    } else if (!industryFlag && obj.industry !== "00") {
      // if general industries are requested then dump anything not 00/all
      return;
    }

    if (geographyFlag && obj.geography === "00") {
      // if detailed geographies are requested dump 00/all
      return;
    } else if (!geographyFlag && obj.geography !== "00") {
      // if general geographies are requested then dump anything not 00/all
      return;
    }

    // keep cipcode label:
    d3Entry.degree = obj.cipcode_label;

    // keep industry label if flagged
    if (industryFlag) {
      d3Entry.industry = obj.industry_label;
    }

    // keep geography label if flagged
    if (geographyFlag) {
      if (obj.geography === instateGeography) {
        d3Entry.geography = obj.geography_label; // the instate-geography entry
        let d3EntryOutState = JSON.parse(JSON.stringify(d3Entry)); // out-of-state entry

        // label the instate geography as just state
        instateDivision = d3Entry.geography;
        d3Entry.geography = `${fipsToState[institution_statefips]}`;
        d3Entry.value = obj[`y${flowsSelectedCut}_grads_emp_instate`];

        // out of state but in division is labeled Division (out-of-state)
        d3EntryOutState.geography += " Balance";
        d3EntryOutState.value =
          obj[`y${flowsSelectedCut}_grads_emp`] -
          obj[`y${flowsSelectedCut}_grads_emp_instate`];

        // if there is no hidden filter
        if (!hiddenFilterString) {
          // if data exists, push it to the array
          if (d3Entry.value > 0) {
            d3Data.push(d3Entry);
          }
          if (d3EntryOutState.value > 0) {
            d3Data.push(d3EntryOutState);
          }
        } else {
          // if there is a hidden filter only show the one selected
          if (d3Entry.value > 0 && hiddenFilterString === "instate") {
            d3Data.push(d3Entry);
          }
          if (
            d3EntryOutState.value > 0 &&
            hiddenFilterString === "outofstate"
          ) {
            d3Data.push(d3EntryOutState);
          }
        }
      } else {
        d3Entry.geography = obj.geography_label;
        d3Entry.value = obj[`y${flowsSelectedCut}_grads_emp`];
        if (d3Entry.value > 0) {
          d3Data.push(d3Entry);
        }
      }
    } else {
      d3Entry.value = obj[`y${flowsSelectedCut}_grads_emp`];
      if (d3Entry.value > 0) {
        d3Data.push(d3Entry);
      }
    }
  });

  // if the data contains an all category plus another
  if (
    cipCodeFilter.some(obj => obj.cipCode === "00") &&
    cipCodeFilter.some(obj => obj.cipCode !== "00")
  ) {
    d3Data = patchAll(d3Data, flowsOptions, cipCodeFilter);
  }

  // calculate sharre
  if (flowsDisplay === "share") {
    let selectedTotal = 0;

    d3Data.forEach(obj => {
      selectedTotal += obj.value;
    });

    d3Data.forEach(obj => {
      obj.value = (obj.value * 1.0) / selectedTotal;
    });
  }

  let d3Keys = ["degree", ...flowsOptions];

  return generateGraph(d3Keys, d3Data);
}

function generateGraph(keys, data) {
  let index = -1;
  const nodes = [];
  const nodeByKey = new Map();
  const indexByKey = new Map();
  const links = [];

  for (const k of keys) {
    for (const d of data) {
      const key = JSON.stringify([k, d[k]]);
      if (nodeByKey.has(key)) continue;
      const node = { name: d[k] };
      nodes.push(node);
      nodeByKey.set(key, node);
      indexByKey.set(key, ++index);
    }
  }

  for (let i = 1; i < keys.length; ++i) {
    const a = keys[i - 1];
    const b = keys[i];
    const prefix = keys.slice(0, i + 1);
    const linkByKey = new Map();
    for (const d of data) {
      const names = prefix.map(k => d[k]);
      const key = JSON.stringify(names);
      const value = d.value || 1;
      let link = linkByKey.get(key);
      if (link) {
        link.value += value;
        continue;
      }
      link = {
        source: indexByKey.get(JSON.stringify([a, d[a]])),
        target: indexByKey.get(JSON.stringify([b, d[b]])),
        names,
        value
      };
      links.push(link);
      linkByKey.set(key, link);
    }
  }

  return { nodes, links };
}

function clearSankey() {
  let contents = d3
    .select(chartDiv)
    .select("svg")
    .select("g.chart")
    .select("g.contents");

  contents
    .select("g.nodes")
    .selectAll("*")
    .remove();
  contents
    .select("g.links")
    .selectAll("*")
    .remove();
  contents
    .select("g.labels")
    .selectAll("*")
    .remove();
}

function setHiddenFilter(node, pseoData) {
  // take the clicked node depth (the 0 cip column cant be clicked on)
  // and extract whether the clicked node was 'industry' or 'geography'
  // add the "_label" string since that's what appears in the cipCodeData
  let propName = `${pseoData.flowsOptions[node.depth - 1]}_label`;
  // save the filter just incase
  hiddenFilter = true;
  // filter the cipcode data using the selected node
  let tempCipCodeData = pseoData.cipCodeData.filter(obj => {
    return obj[propName] === node.name;
  });
  if (tempCipCodeData.length === 0) {
    pseoData.cipCodeData = pseoData.cipCodeData.filter(obj => {
      return obj[propName] === instateDivision;
    });

    if (node.name.includes("Balance")) {
      hiddenFilterString = "outofstate";
      updateD3SankeyChart(pseoData);
    } else {
      hiddenFilterString = "instate";
      updateD3SankeyChart(pseoData);
    }
  } else {
    pseoData.cipCodeData = tempCipCodeData;
    updateD3SankeyChart(pseoData);
  }
}

let clearHiddenFilterBindClickEvent = function(pseoData) {
  $j33(window).unbind("click");
  $j33(window).click(function(event) {
    // if flows data is selected and click is in the chart clear the hidden filter and redraw
    if (
      hiddenFilter &&
      $j33("#data-type-toggle > label.active").attr("id") === "flows-label" &&
      (event.target.tagName === "svg" || event.target.tagName === "path")
    ) {
      hiddenFilter = false;
      hiddenFilterString = null;
      // refilter the API data
      pseoData.cipCodeData = pseoData.data.filter(function(e) {
        return this.indexOf(e.cipcode) !== -1;
      }, pseoData.cipCodeFilter.map(obj => obj.cipCode));

      // re render the chart`
      updateD3SankeyChart(pseoData);
    }
  });
};

function formatNumericLabels(flowsDisplay, d) {
  if (flowsDisplay === "share") {
    let x = parseFloat(d.value) * 100;
    return ` ${x.toFixed(0)}%`;
  } else {
    return ` ${d.value.toLocaleString()}`;
  }
}

function formatNumericLabelsTooltip(flowsDisplay, d) {
  if (flowsDisplay === "share") {
    let x = parseFloat(d.value) * 100;
    return ` ${x.toFixed(2)}%`;
  } else {
    return ` ${d.value.toLocaleString()}`;
  }
}

export function addNoDataTexttoChart() {
  let width = +chartDiv.clientWidth - margin.left - margin.right;
  let height = +chartDiv.clientHeight - margin.top - margin.bottom;

  let svg = d3.select(chartDiv).select("svg");
  svg
    .select("g.chart")
    .select("g.contents")
    .append("g")
    .attr("class", "notifications")
    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
    .append("text")
    .attr("font-family", "Helvetica, Arial, sans-serif;")
    .attr("font-weight", "bold")
    .attr("fill", "#6c757d")
    .attr("text-anchor", "middle")
    .text("No Data Available for Selected Program and Years-Postgrad Filter");
}

function bindingStrategy(d) {
  // perform all data binding via one mechanism
  if (
    ["All Instructional Programs", "All Other Instructional Programs"].includes(
      d.name
    )
  ) {
    return "All";
  } else {
    return d.name;
  }
}

export function updateD3SankeyChart(pseoData) {
  // pseoData = global object from the main app controller
  // hiddenFilter/hiddenFilterString = a flag to notify the filter whether to display the instate/outofstate
  //    flows to geography. This is only used in the click function "setHiddenFilter" above
  let graphData = [];
  let sankeyData = {};

  // reset the highlights when chart changes
  d3.selectAll(".link").style("stroke-opacity", null);

  // if no degrees are selected clear the chart
  if (pseoData.cipCodeFilter.length === 0) {
    formatD3NoDataSankey(pseoData); // hacky fix to label all button and return
    clearSankey();
    clearSuppressionText();
    addSelectDegreeTexttoChart();
    return;
  } else {
    removeNotificationTextfromChart();
  }

  // update the width/height of the chart
  sankey.extent([[0, 5], [width, height - 5]]);

  // draw the labels
  reDrawYAxisLabels(pseoData.flowsDisplay);

  // Fallback layout if no flows options are available
  // * clean up duplicates
  if (pseoData.flowsOptions.length === 0) {
    graphData = formatD3NoDataSankey(pseoData);
  } else {
    if (hiddenFilter) {
      //FIXME: hidden filter and type are globals, refactor
      graphData = formatD3DataSankey(pseoData, hiddenFilterString);
    } else {
      graphData = formatD3DataSankey(pseoData);
    }
  }

  if (graphData.nodes === undefined || graphData.nodes == 0) {
    clearSankey();
    addNoDataTexttoChart();
    return; // if the graph data is empty, don't do anythng
  }

  sankeyData = sankey(graphData);

  // get the root labels for coloring
  let cipLabels = [];
  sankeyData.nodes.forEach(val => {
    if (val.depth === 0) {
      cipLabels.push(val.name);
    }
  });

  // get the minimum and maximum value for color/text scaling
  let maxVal = Math.max.apply(
    Math,
    sankeyData.nodes.map(function(o) {
      return o.value;
    })
  );
  let minVal = Math.min.apply(
    Math,
    sankeyData.nodes.map(function(o) {
      return o.value;
    })
  );

  let darkColorScheme = d3.schemeCategory20.map((hex, idx) => {
    if (idx === 1) {
      return d3.color("#7195c7");
    } else {
      return d3.color(hex);
    }
  });

  // root color scheme
  const rootNodes = sankeyData.nodes
    .filter(v => v.depth === 0)
    .sort(nodeSort)
    .map(f => f.name);
  // repeat the color scheme if need be
  let repArray =
    darkColorScheme.length >= rootNodes.length
      ? 1
      : Math.ceil(rootNodes.length / darkColorScheme.length);
  let rootColorScheme = [].concat(...Array(repArray).fill(darkColorScheme));
  const rootColors = d3
    .scaleOrdinal()
    .domain(rootNodes)
    .range(rootColorScheme)
    .unknown("#ccc");

  // add text for selections that don't appear in rootNodes
  addSuppressionText(rootNodes, pseoData.cipCodeFilter);

  // first child color scheme
  const levOneNodes = sankeyData.nodes
    .filter(v => v.depth === 1)
    .sort(nodeSort)
    .map(f => f.name);
  let levOneColors = function() {};
  if (pseoData.flowsOptions.length === 0) {
    // if the fallback flows is active
    levOneColors = d3
      .scaleSequential()
      .domain([0, levOneNodes.length - 1])
      .interpolator(d3.interpolateRgb("#60c96e", "#ccc"));
  } else {
    // if either industry or geography flows are active
    levOneColors = d3
      .scaleSequential()
      .domain([0, levOneNodes.length - 1])
      .interpolator(d3.interpolateViridis);
  }

  // second child color scheme
  const levTwoNodes = sankeyData.nodes
    .filter(v => v.depth === 2)
    .sort(nodeSort)
    .map(f => f.name);
  const levTwoColors = d3
    .scaleSequential()
    .domain([0, levTwoNodes.length - 1])
    .interpolator(d3.interpolateMagma);

  const nodeColor = function(v) {
    if (rootNodes.includes(v)) {
      return rootColors(v);
    } else if (levOneNodes.includes(v)) {
      return levOneColors(levOneNodes.indexOf(v));
    } else if (levTwoNodes.includes(v)) {
      return levTwoColors(levTwoNodes.indexOf(v));
    }
  };

  const linkColor = d3
    .scaleOrdinal()
    .domain(["All Instructional Programs", "All Other Instructional Programs"])
    .range(["#c4bade", "#bacade"])
    //.unknown("#ccc");
    .unknown(d3.rgb("#ccc").darker(0.6));

  //options flags
  let industryFlag = pseoData.flowsOptions.includes("industry");
  let geographyFlag = pseoData.flowsOptions.includes("geography");

  // scale the text of the chart by the div width
  let textScale = +chartDiv.clientWidth / 1200;

  // scale the text based on the options flags
  let maxFontSize = textScale * (industryFlag && geographyFlag ? 20 : 25);
  let minFontSize = textScale * (industryFlag && geographyFlag ? 10 : 10);

  const fontScale = d3
    .scaleLinear()
    .domain([minVal, maxVal])
    .range([minFontSize, maxFontSize]);

  let contents = d3
    .select(chartDiv)
    .select("svg")
    .select("g.chart")
    .select("g.contents");

  let nodes = contents
    .select("g.nodes")
    .selectAll("rect")
    .data(sankeyData.nodes, d => bindingStrategy(d));

  let labels = contents
    .select("g.labels")
    .selectAll("text")
    .data(sankeyData.nodes, d => bindingStrategy(d));

  let links = contents
    .select("g.links")
    .attr("fill", "none")
    .selectAll("path")
    .data(sankeyData.links, d => bindingStrategy(d));

  let linkTransitionDuration = transitionDuration * 2;

  // only use the transition when under the hardcoded limit
  let doAnimate = sankeyData.links.length <= SANKEYLINKLIMIT;

  // render nodes
  if (doAnimate) {
    //remove old
    nodes
      .exit()
      .transition()
      .duration(transitionDuration)
      .attr("y", height)
      .attr("height", 0)
      .style("opacity", 0)
      .remove();

    // update existing
    nodes
      .transition()
      .duration(transitionDuration)
      .attr("x", d => d.x0)
      .attr("y", d => d.y0)
      .attr("height", d => d.y1 - d.y0)
      .attr("width", d => d.x1 - d.x0)
      .style("opacity", 1)
      .style("fill", d => {
        return d3.rgb(nodeColor(d.name));
      })
      .style("stroke", function(d) {
        return d3.rgb(d.color).darker(1.8);
      });

    // add new
    nodes
      .enter()
      .append("rect")
      .attr("class", "node")
      .on("click", d => {
        if (
          d.depth !== 0 &&
          (pseoData.flowsOptions.includes("industry") ||
            pseoData.flowsOptions.includes("geography"))
        ) {
          clearHiddenFilterBindClickEvent(pseoData);
          setHiddenFilter(d, pseoData);
        }
      })
      .attr("x", d => d.x0)
      .attr("y", height)
      .attr("height", 0)
      .attr("width", d => d.x1 - d.x0)
      .style("opacity", 0)
      .transition()
      .duration(transitionDuration)
      .style("opacity", 1)
      .attr("x", d => d.x0)
      .attr("y", d => d.y0)
      .attr("height", d => d.y1 - d.y0)
      .attr("width", d => d.x1 - d.x0)
      .style("fill", function(d) {
        return (d.color = nodeColor(d.name));
      })
      .style("stroke", function(d) {
        return d3.rgb(d.color).darker(1.8);
      });

    links
      .exit()
      .transition()
      .duration(linkTransitionDuration)
      .attr("stroke-width", 0)
      .style("stroke-opacity", 0)
      .remove();

    links
      .style("stroke-opacity", 0)
      .transition()
      .attr("d", sankeyLinkHorizontal())
      .attr("stroke", d => linkColor(d.names[0]))
      .attr("stroke-width", d => d.width)
      .style("stroke-opacity", null)
      .transition()
      .duration(linkTransitionDuration);

    links
      .enter()
      .append("path")
      .attr("class", "link")
      .attr("d", sankeyLinkHorizontal())
      .attr("id", function(d, i) {
        d.id = i;
        return "link-" + i;
      })
      .attr("stroke", d => linkColor(d.names[0]))
      .attr("stroke-width", d => d.width)
      .style("mix-blend-mode", "multiply")
      .style("stroke-opacity", 0)
      .transition()
      .style("stroke-opacity", null)
      .transition()
      .duration(linkTransitionDuration);

    // remove old
    labels
      .exit()
      .transition()
      .duration(transitionDuration)
      .attr("y", height)
      .attr("height", 0)
      .style("opacity", 0)
      .remove();

    // update the displayed value then transition
    labels
      .text(d => {
        if (d.name.startsWith("No or very")) {
          return d.name;
        }
        // if both geography and industry are selected, trim down label length
        if (industryFlag && geographyFlag) {
          if (d.name.length > 20) {
            return `${d.name.slice(0, d.name.indexOf(" ", 20))}...`;
          }
          return d.name;
        } else {
          if (d.name.length > 33) {
            return `${d.name.slice(0, d.name.indexOf(" ", 33))}...`;
          }
          return d.name;
        }
      })
      .append("tspan")
      .attr("fill-opacity", 0.7)
      .text(d => formatNumericLabels(pseoData.flowsDisplay, d));

    labels
      .transition()
      .duration(transitionDuration)
      .style("opacity", 1)
      .style("font-size", d => Math.floor(fontScale(d.value)) + "px")
      .style("fill", d => {
        return d3.rgb(nodeColor(d.name)).darker(0.8);
      })
      .attr("x", d => (d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6))
      .attr("y", d => (d.y1 + d.y0) / 2)
      .attr("text-anchor", d => (d.x0 < width / 2 ? "start" : "end"));

    // add new
    let labelEnterParent = labels
      .enter()
      .append("text")
      .attr("class", "nodetext")
      .style("fill", d => d3.rgb(nodeColor(d.name)).darker(0.8))
      .style("font-size", "0px")
      .attr("font-weight", "bold")
      .attr("x", d => (d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6))
      .attr("y", height)
      .attr("dy", "0.35em")
      .text(d => {
        if (d.name.startsWith("No or very")) {
          return d.name;
        }
        // if both geography and industry are selected, trim down label length
        if (industryFlag && geographyFlag) {
          if (d.name.length > 20) {
            return `${d.name.slice(0, d.name.indexOf(" ", 20))}...`;
          }
          return d.name;
        } else {
          if (d.name.length > 33) {
            return `${d.name.slice(0, d.name.indexOf(" ", 33))}...`;
          }
          return d.name;
        }
      })
      .attr("text-anchor", d => (d.x0 < width / 2 ? "start" : "end"));

    labelEnterParent
      .append("tspan")
      .attr("fill-opacity", 0.7)
      .text(d => formatNumericLabels(pseoData.flowsDisplay, d));

    labelEnterParent
      .style("opacity", 0)
      .transition()
      .duration(transitionDuration)
      .attr("y", d => (d.y1 + d.y0) / 2)
      .style("font-size", d => Math.floor(fontScale(d.value)) + "px")
      .style("opacity", 1);
  } else {
    // if the transition is getting choppy clear and redraw
    contents
      .selectAll("g.nodes")
      .selectAll("rect")
      .remove();
    contents
      .selectAll("g.links")
      .selectAll("path")
      .remove();
    contents
      .selectAll("g.labels")
      .selectAll("text")
      .remove();

    // rebind
    let nodes = contents
      .select("g.nodes")
      .selectAll("rect")
      .data(sankeyData.nodes, d => bindingStrategy(d));

    let labels = contents
      .select("g.labels")
      .selectAll("text")
      .data(sankeyData.nodes, d => bindingStrategy(d));

    let links = contents
      .select("g.links")
      .attr("fill", "none")
      .selectAll("path")
      .data(sankeyData.links, d => bindingStrategy(d));

    nodes
      .enter()
      .append("rect")
      .attr("class", "node")
      .on("click", d => {
        if (
          d.depth !== 0 &&
          (pseoData.flowsOptions.includes("industry") ||
            pseoData.flowsOptions.includes("geography"))
        ) {
          clearHiddenFilterBindClickEvent(pseoData);
          setHiddenFilter(d, pseoData);
        }
      })
      .style("opacity", 1)
      .attr("x", d => d.x0)
      .attr("y", d => d.y0)
      .attr("height", d => d.y1 - d.y0)
      .attr("width", d => d.x1 - d.x0)
      .style("fill", d => {
        return d3.rgb(nodeColor(d.name));
      })
      .style("stroke", function(d) {
        return d3.rgb(d.color).darker(1.8);
      });

    links
      .enter()
      .append("path")
      .attr("class", "link")
      .attr("d", sankeyLinkHorizontal())
      .attr("id", function(d, i) {
        d.id = i;
        return "link-" + i;
      })
      .attr("stroke", d => linkColor(d.names[0]))
      .attr("stroke-width", d => d.width)
      .style("mix-blend-mode", "multiply")
      .style("stroke-opacity", null);

    let labelEnterParent = labels
      .enter()
      .append("text")
      .attr("class", "nodetext")
      .style("fill", d => d3.rgb(nodeColor(d.name)).darker(0.8))
      .style("font-size", "0px")
      .attr("font-weight", "bold")
      .attr("x", d => (d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6))
      .attr("y", height)
      .attr("dy", "0.35em")
      .text(d => {
        if (d.name.startsWith("No or very")) {
          return d.name;
        }
        // if both geography and industry are selected, trim down label length
        if (industryFlag && geographyFlag) {
          if (d.name.length > 20) {
            return `${d.name.slice(0, d.name.indexOf(" ", 20))}...`;
          }
          return d.name;
        } else {
          if (d.name.length > 33) {
            return `${d.name.slice(0, d.name.indexOf(" ", 33))}...`;
          }
          return d.name;
        }
      })
      .attr("text-anchor", d => (d.x0 < width / 2 ? "start" : "end"));

    labelEnterParent
      .append("tspan")
      .attr("fill-opacity", 0.7)
      .text(d => formatNumericLabels(pseoData.flowsDisplay, d));

    labelEnterParent
      .attr("y", d => (d.y1 + d.y0) / 2)
      .style("font-size", d => Math.floor(fontScale(d.value)) + "px")
      .style("opacity", 1);
  }

  // tooltips
  var chart = d3.select(".chartcontainer");
  chart.selectAll(".tooltip").remove();
  var tooltip = chart
    .append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

  chart
    .selectAll("path")
    .on("mousemove", function(d) {
      tooltip
        .transition()
        .duration(200)
        .style("opacity", 1);

      tooltip
        .html(function() {
          if (d.names) {
            return `${d.names.join(" → ")}<br\>${formatNumericLabelsTooltip(
              pseoData.flowsDisplay,
              d
            )}`;
          }
        })
        .style("left", function() {
          return d3.event.pageX + 14 + "px";
        })
        .style("top", function() {
          return d3.event.pageY - 42 + "px";
        });
    })
    .on("mouseout", function() {
      tooltip
        .transition()
        .duration(500)
        .style("opacity", 0);
    })
    .on("mouseover", function() {
      tooltip
        .transition()
        .duration(500)
        .style("opacity", 0);
    });

  contents
    .selectAll("rect")
    .on("mouseout", function(d) {
      if (
        d.depth !== 0 &&
        (pseoData.flowsOptions.includes("industry") ||
          pseoData.flowsOptions.includes("geography"))
      ) {
        d3.select(d3.event.target).style("stroke-width", 1);
      }
    })
    .on("mouseover", function(d) {
      if (
        d.depth !== 0 &&
        (pseoData.flowsOptions.includes("industry") ||
          pseoData.flowsOptions.includes("geography"))
      ) {
        d3.select(d3.event.target).style("stroke-width", 3);
      }
    });

  // labeled as 'program' but called 'degree' in code here
  updateD3SankeyAxis(["program", ...pseoData.flowsOptions], nodes);

  return contents.node();
}

function updateD3SankeyAxis(labels) {
  let svg = d3.select(chartDiv).select("svg");
  let axis = svg.select("g.chart").select("g.xaxis");

  //scale the column labels the same as the text labels
  let textScale = +chartDiv.clientWidth / 1200;

  // if the view is the fallback, add a right column
  if (labels.length === 1) {
    labels.push("status");
  }

  // linearly space the axis labels using the margin and node width (24)
  let wrapWidth = margin.left + 12;
  let spacing = linspace(0 + 12, width - 12, labels.length);
  let axisData = [];
  labels.forEach((v, i) => {
    let obj = {};
    obj.text = v;
    obj.x = spacing[i];
    obj.size = `${Math.round(16 * textScale)}px`;
    axisData.push(obj);
  });

  // bind data
  let axisLabels = axis.selectAll("text").data(axisData, d => d.text);

  axisLabels
    .exit()
    .transition()
    .duration(transitionDuration)
    .attr("y", -margin.top)
    .style("opacity", 0)
    .remove();

  axisLabels
    .transition()
    .duration(transitionDuration)
    .attr("x", d => d.x)
    .attr("y", -margin.top / 4)
    .text(d => d.text)
    .style("font-size", d => d.size)
    .style("text-transform", "capitalize")
    .style("font-weight", "bold")
    .style("opacity", 1)
    .attr("font-family", "Helvetica, Arial, sans-serif;")
    .attr("text-anchor", "middle")
    .attr("class", "text-color");

  axisLabels
    .enter()
    .append("text")
    .attr("y", 0)
    .attr("x", d => d.x)
    .attr("height", 0)
    .style("opacity", 0)
    .text(d => d.text)
    .style("font-size", d => d.size)
    .style("text-transform", "capitalize")
    .style("font-weight", "bold")
    .attr("font-family", "Helvetica, Arial, sans-serif;")
    .attr("text-anchor", "middle")
    .attr("class", "text-color")
    .transition()
    .duration(transitionDuration)
    .attr("y", -margin.top / 4)
    .style("opacity", 1);
}
